/**
 * rankingPhotoCardContainer.tsx
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Get the style for the RankingPhotoCardContainer component.
 */
function getPositionStyle(position?: number, vertical?: boolean) {
  let marginRight = 0;
  let letterSpacing = 0;
  switch (position) {
    case 1:
      marginRight = vertical ? -28 : -24;
      break;
    case 2:
      marginRight = vertical ? -60 : -50;
      break;
    case 3:
      marginRight = vertical ? -60 : -50;
      break;
    case 4:
      marginRight = vertical ? -48 : -38;
      break;
    case 5:
      marginRight = vertical ? -66 : -50;
      break;
    case 6:
      marginRight = vertical ? -68 : -52;
      break;
    case 7:
      marginRight = vertical ? -76 : -60;
      break;
    case 8:
      marginRight = vertical ? -76 : -60;
      break;
    case 9:
      marginRight = vertical ? -76 : -60;
      break;
    case 10:
      marginRight = vertical ? -50 : -30;
      letterSpacing = -35;
      break;
    default:
      if (position && position > 9) {
        marginRight = vertical ? -8 : 0;
        letterSpacing = vertical ? -35 : -35;
      } else {
        marginRight = vertical ? -50 : -50;
      }
  }
  return {
    marginRight: `${marginRight * Screen.widthRatio}px`,
    letterSpacing: `${letterSpacing * Screen.widthRatio}px`,
  };
}

/**
 * Styled ranking photo card container.
 */
const RankingPositionContainer = styled.div<{
  hide?: boolean;
  position?: number;
  vertical?: boolean;
}>`
  align-items: center;
  color: white;
  display: ${(props) => (props.hide ? 'none' : 'flex')};
  flex-direction: column;
  font-family: SFCompactDisplay-Thin;
  font-size: ${({ vertical }) => (vertical ? 306 : 250) * Screen.widthRatio}px;
  margin-top: ${({ vertical }) => (vertical ? 125 : 0) * Screen.widthRatio}px;
  line-height: ${({ vertical }) => (vertical ? '0.76' : '0.86')};
  text-align: center;
  ${({ position, vertical }) => getPositionStyle(position, vertical)}
`;

export default RankingPositionContainer;
